<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <div class="site-logo logo-big">
        <a class="navbar-brand" (click)="logologout()">
          <img class="logo-icon me-2" src="assets/images/logo_new_1.png" alt="logo"
            style="height: 40px; margin-left: 1rem;">
        </a>
      </div>
    </div>
      <div class="d-flex">
        <div class="dropdown d-inline-block">
          <button type="button" class="header-item" style="background-color: #fff" (click)="supportData()" title="Customer Support">
            <span class="d-none d-xl-inline-block ms-1"><i class="bx bx-support" style="font-size: 20px;"></i></span>
          </button>
      </div>
        <ng-container *ngIf="user =='admin'">
        <div class="dropdown d-inline-block">
          <button type="button" class="header-item" style="background-color: #fff" routerLink="/adlp/adminview">
            <span class="d-none d-xl-inline-block ms-1">Admin Dashboard</span>
          </button>
      </div>
    </ng-container>
        <div class="dropdown d-inline-block">
          <button type="button" class="header-item" style="background-color: #fff">
            <span class="d-none d-xl-inline-block ms-1">Welcome! {{loginUser?.name | titlecase}}</span>
          </button>
        </div>
        <div class="dropdown d-inline-block">
          <button type="button" class="header-item" style="background-color: #fff">
            <span class="d-none d-xl-inline-block ms-1 search" style="margin-top: -12px;">
              <a class="data-demo btn-primary text-white view-more" href="javascript:(void)" (click)="logout()">Logout</a>
            </span>
          </button>
        </div>
      </div>
  </div>
</header>
<app-common-header></app-common-header>